/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyershort2Inputs */

const en_checkinflyershort2 = /** @type {(inputs: Checkinflyershort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

const de_checkinflyershort2 = /** @type {(inputs: Checkinflyershort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer`)
};

/**
* | output |
* | --- |
* | "Flyer" |
*
* @param {Checkinflyershort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyershort2 = /** @type {((inputs?: Checkinflyershort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyershort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyershort2(inputs)
	return de_checkinflyershort2(inputs)
});
export { checkinflyershort2 as "checkinFlyerShort" }